<template>
  <div  id="container">
      <div style="height: 100vh; width: 100vw;">
        <div style="height: 40px">
          <el-affix :offset="0">
            <div style="height: 40px;line-height: 40px;background-color: rgb(30, 159, 255);">
              <img src="../assets/images/company.png" style="height: 30px; width: 30px;margin: 5px 10px;float: left">
              <h2 style="float:left;font-size: 15px;letter-spacing: 2px;color: #F5F7FA">
                <span >销售送货单管理模块V1.0</span>
              </h2>
              <el-button style="float: right; width: 60px;margin-top: 4px;margin-right: 5px" round type="primary" @click="onLogout(true)"  >
                登出
              </el-button>
            </div>
          </el-affix>
        </div>
        <el-row>
          <el-col :span="22" :offset="1">
            <div v-infinite-scroll="() => {}"   :style="{'height': (height - 40) + 'px'}" style="overflow: auto">
              <el-card style="margin-top: 10px;position: relative" >
                <div>
                  <CUOutboundOrder @search="onSearch" @createdProject="list" :mode="'create'" :init-value="searchCondition"/>
                  <div id="main-table">
                    <el-table  :data="tableData"    table-layout="auto"  style="width: 100%" border v-loading="loadingData"  element-loading-text="数据加载中, 请稍后" stripe >
                      <el-table-column type="index" fixed width="50" :index="index => index + 1 + ((pageInfo.current - 1) * 10)"/>
                      <el-table-column prop="order_id" label="送货单号" width="200" show-overflow-tooltip header-align="center"></el-table-column>
                      <el-table-column prop="out_date" label="送货日期" width="110" show-overflow-tooltip header-align="center" align="center"></el-table-column>
                      <el-table-column prop="salesman" label="数量合计" width="150"  show-overflow-tooltip header-align="center" align="center">
                        <template #default="scope">
                          {{scope.row.total ?? ''}}
                        </template>
                      </el-table-column>
                      <el-table-column prop="cname"  label="客户名称" width="200" show-overflow-tooltip header-align="center" align="center"></el-table-column>
                      <el-table-column prop="salesman" label="业务员" width="100"  show-overflow-tooltip header-align="center" align="center"></el-table-column>
                      <el-table-column prop="plan" label="生产计划" width="400" show-overflow-tooltip header-align="center"/>
                      <el-table-column prop="remark" label="备注" width="200" show-overflow-tooltip header-align="center"/>
                      <el-table-column label="" fixed="right" header-align="center">
                        <template #default="scope">
                          <el-button link size="small" type="primary" @click.prevent="viewDetail(scope.row)">查看</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <div style="margin-top: 10px;" >
                  <el-pagination style="float: right;height: 50px; line-height: 50px;margin-right: 2px" layout="total, prev, pager, next, slot" :total="pageInfo.total" :pager-count="3" :page-size="pageInfo.pageSize" v-model:current-page="pageInfo.current" @current-change="list">
                    <el-button circle @click="list" >
                      <el-icon :class="loadingData ? 'is-loading' : ''"><Refresh /></el-icon>
                    </el-button>
                  </el-pagination>
                </div>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </div>
  </div>
</template>
<script setup>
import {Refresh} from '@element-plus/icons-vue';
import { ElMessage} from 'element-plus';
import {useSize} from '../assets/js/size';
import {computed, onBeforeUnmount, onMounted, ref, watch,} from "vue";
import {useRouter} from "vue-router";
import axios from 'axios';
import {get,confirm} from "@/assets/js/utils";
import CUOutboundOrder from "@/components/CUOutboundOrder";
import {search} from "@/assets/js/config";
// const BASE_URL = 'http://192.168.5.104:8080/invoicing_war_exploded';
// const BASE_URL = window.location.host == "192.168.200.67" ? 'http://192.168.200.67:8080/oa' : 'https://fp.spepi.cn/oa';
// const BASE_URL = 'http://192.168.200.188:8081/odo';
const BASE_URL = 'https://shd.spepi.cn/odo';
axios.defaults.baseURL = BASE_URL;
let {height, width} = useSize();
let router = useRouter();

const searchCondition = search.value.mainPage;

function viewDetail(project){
  router.push("/report/" + project.id)
}

const isSmall = computed(() => width.value < 630);


const pageInfo = search.value.mainPage.pageInfo


const tableData = ref([]);



const loadingData = ref(false);

function searchParam(){
  const keyword = searchCondition.keyword === null ? '' : '&keyword=' + searchCondition.keyword;
  if(searchCondition.status == null){
    searchCondition.reject = null;
  }
  else if (searchCondition.status == '-1'){
    searchCondition.reject = true;
  }
  else {
    searchCondition.reject = false;
  }
  const type = '&type=' + ((searchCondition.type != null) ?  searchCondition.type : '');
  const status = '&status=' + (searchCondition.status != null ?  ((searchCondition.status == '-1') ? '2' : searchCondition.status)   : "");
  const has_contract = searchCondition.has_contract === null ? '' : '&has_contract=' + (searchCondition.has_contract ? 1 : 0);
  const reject = searchCondition.reject == null ? '' : '&reject=' + (searchCondition.reject ? 1 : 0);
  const begin = searchCondition.begin == null ? '' : ('&begin=' +  searchCondition.begin);
  const end = searchCondition.end == null ? '' : ('&end=' +  searchCondition.end);
  const range = searchCondition.range == null ? '' : '&range=' + searchCondition.range;
  return status + has_contract + reject + keyword + begin + end + range  + type;
}

function list(callback) {
  pageInfo.pageSize = 10;
  loadingData.value = true;
  get(`/list?pageSize=${pageInfo.pageSize}&pageNum=${pageInfo.current}` + searchParam(), ({data, code}) => {
    if (code == 0){
      let result = data.data;
      pageInfo.total = result.total;
      setTimeout(() => {
        tableData.value = result.list
        if (callback){
          if ((typeof callback == 'function')){
            callback();
          }
          else {
            if (callback.id){
              viewDetail(callback)
            }
          }
        }
      }, 500)
    }
  }, () => {
    tableData.value = []
  }, () => {
    setTimeout(() => loadingData.value = false, 600)
  })
}



function onSearch(keyword, range){
  searchCondition.keyword = keyword;
  searchCondition.range = range;
  list();
}


watch(isSmall, function () {
  list();
  searchCondition.range = null;
})

watch(() => searchCondition.type, newType => {
  if (newType == 1) return;
  if (newType == -1){
    searchCondition.has_contract = null;
  }
  loadingData.value = true;
})

function onTouch(event){
  if (event.touches.length > 1) {
    event.preventDefault();
  }
}


onMounted(() => {
  list();
  let container = document.getElementById('container');
  container.addEventListener('touchstart', onTouch, false);
  // 启用双击缩放
  container.addEventListener('touchend', onTouch, false);
})

onBeforeUnmount(() => {
  let container = document.getElementById('container');
  container.removeEventListener('touchstart', onTouch, false);
  container.removeEventListener('touchend', onTouch, false);
})



function logout(){
  console.log(localStorage.getItem("user"))
  localStorage.removeItem('user');
   router.push("/login")
}

const onLogout = function (info){
  if (!info){
    logout();
    return;
  }
  confirm('确认退出登录？', logout, () => ElMessage({message: '已取消', type: 'info'}))
}



</script>

